"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TremendousCampaign = exports.GiftCard = exports.GiftCardDenomination = void 0;
const zod_1 = require("zod");
exports.GiftCardDenomination = zod_1.z.object({
    value: zod_1.z.number(),
    discount: zod_1.z.number().optional(),
});
exports.GiftCard = zod_1.z.object({
    id: zod_1.z.string(),
    denomination: zod_1.z.array(exports.GiftCardDenomination),
    externalId: zod_1.z.string(),
    name: zod_1.z.string(),
    image: zod_1.z.string(),
    ordering: zod_1.z.number(),
    terms: zod_1.z.string(),
    fee: zod_1.z.number().optional(),
    minFeeValue: zod_1.z.number().optional(),
});
exports.TremendousCampaign = zod_1.z.object({
    id: zod_1.z.string(),
    denomination: zod_1.z.array(exports.GiftCardDenomination),
    campaignId: zod_1.z.string(),
    name: zod_1.z.string(),
    image: zod_1.z.string(),
});
